import React from 'react'
import EssayReviewDrawer from 'pages/Dashboard/components/TodaysPrioritySection/components/EssayReviewDrawer/EssayReviewDrawer'
const ApplicationEssayReviewDrawer = ({ controller }) => {
	const api = controller
	if (!api?.open) return null

	return (
		<EssayReviewDrawer
			variant="application"
			items={api.drawerItems}
			index={api.essayIndex}
			onClose={api.closeDrawer}
			onNavigate={api.navigateEssay}
			onChanged={api.refreshSummary}
			onResolvePending={api.handleResolvePending}
			controlled={{
				version: api.version,
				loading: api.loading,
				feedbackItems: api.feedbackItems,
				feedbackLoading: api.feedbackLoading,
				unreadStudentCount: api.unreadStudentCount,
				setFeedbackItems: api.setFeedbackItems,
				setUnreadStudentCount: api.setUnreadStudentCount,
				reloadFeedback: api.reloadFeedback,
				versionsMeta: api.versionsMeta,
				activeVersionId: api.activeVersionId,
				onVersionSelect: api.selectVersion,
				listPanelOpen: api.listPanelOpen,
				onToggleListPanel: api.toggleListPanel,
				listPanelItems: api.listPanelItems,
				listLoading: api.listLoading,
				onSelectListEssay: api.selectListEssay,
				activeEssayId: api.activeEssayId,
				pendingUpdate: api.pendingUpdate,
				onApplyPendingUpdate: api.applyPendingUpdate,
			}}
		/>
	)
}

export default ApplicationEssayReviewDrawer
